import DashboardService from '@/services/dashboard';
import { userHaveRoles } from "@/services/utilities"

export default {
	namespaced: true,
  state: {
		invoiceData: null
	},

	getters: {
		
	},

	actions: {
    async getSubmissionRecap({ commit, state, getters, dispatch }, payload) {
			try {
        const response = await DashboardService.getSubmissionRecap(payload);
				return response.data ? response.data.data : []
			} catch (e) {
				console.log(e)
			}
    },
    async getFirstInvoice({ commit, state, getters, dispatch }) {
      try{
        const response = await DashboardService.getFirstInvoice();
        commit('SET_INVOICE_DATA', response.data.attributes)
        return response.data && response.data.attributes ? response.data.attributes : null;
      } catch (e) {
        console.log(e)
      } 
    },
    async approveFirstInvoice({ commit, state, getters, dispatch }, payload) {
      try{
        const response = await DashboardService.approveFirstInvoice();
        return response;
      }catch(e){
        console.log(e)
      }
    }
	},

	mutations: {
		SET_INVOICE_DATA(state, payload) {
			state.invoiceData = payload;
		}
	}
};
